
<template>
  <div class="home">
    <div class="box" @mouseout="out" @mouseover="over">
      <img @click="toUrl(item)" ref="imgRef" v-for="(item, index) in list" v-show="listIndex === index" :key="index" :src="baseUrl+item.picture" alt />
      <p class="left" @click="changePage(prevIndex)" v-show="buttonFlag"> <i class="el-icon-arrow-left"></i></p>
      <ul>
        <li :class="{ color: index == listIndex }" v-for="(item, index) in list" @click="changePage(index)" :key="index"></li>
      </ul>
      <p class="right" @click="changePage(nextIndex)" v-show="buttonFlag"> <i class="el-icon-arrow-right"> </i></p>
    </div>
  </div>
</template>
 
<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      list: [
        require("@/assets/img/banner/banner_1.jpg"),
        require("@/assets/img/banner/banner_2.jpg"),
        require("@/assets/img/banner/banner_3.jpg"),
      ],
      listIndex: 0, //默认显示第几张图片
      timer: null, //定时器
      buttonFlag: false,
      baseUrl: null,
    };
  },
  computed: {
    //上一张
    prevIndex() {
      if (this.listIndex == 0) {
        return this.list.length - 1;
      } else {
        return this.listIndex - 1;
      }
    },
    //下一张
    nextIndex() {
      if (this.listIndex == this.list.length - 1) {
        return 0;
      } else {
        return this.listIndex + 1;
      }
    },
  },

  created() {
    this.getBanner();
  },
  mounted() {},
  methods: {
    getBanner() {
      let parData = {
        page: 1,
        pageSize: 30,
        query: "",
        isShow: "1",
        state: "",
      };
      this.http.post("banner/getBannerInfoPage", parData).then((res) => {
        this.$Loading.hide();
        if (res.code == "0") {
          this.baseUrl = this.common.MediaUrl();
          this.list = res.data.records; //定时器
          this.setTimer();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    changePage(index) {
      this.listIndex = index;
    },
    // 页面跳转
    toUrl(item) {
      console.log(item.url);
      if (item.url != "#" || !item.url) {
        window.open(item.url);
      }
    },
    //移除
    out() {
      this.buttonFlag = false;
      return;
      this.$refs.imgRef[this.listIndex].style.animation = "";
      this.setTimer();
    },
    //移入
    over() {
      this.buttonFlag = true;
      return;
      this.$refs.imgRef[this.listIndex].style.animation = "stop";
      clearInterval(this.timer);
    },
    //1秒切图
    setTimer() {
      this.timer = setInterval(() => {
        this.listIndex++;
        if (this.listIndex == this.list.length) {
          this.listIndex = 0;
        }
      }, 5000);
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/assets/css/_common.scss";
@keyframes bannerMove {
  0% {
    transform: scale(1);
    // opacity: 0.6;
  }

  100% {
    transform: scale(1.1);
    // opacity: 0.9;
  }
}

/*Safari 和 Chrome:*/
@-webkit-keyframes bannerMove {
  from {
    transform: scale(1);
    opacity: 1;
  }
  to {
    transform: scale(1.1);
    opacity: 0.8;
  }
}
.home {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  border: $b-border-white;
  border-radius: $r-mid;
  justify-content: center;
  .box {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
    border-radius: $r-hug;
    background-color: #fff;
    // border: 1px solid lightgray;
    box-shadow: $shadow;
    img {
      width: 100%;
      height: 100%;
      max-height: 920px;
      z-index: 100;
      animation: bannerMove 5s infinite ease-in;
      /*Safari 和 Chrome:*/
      -webkit-animation: bannerMove 5s infinite;
      cursor: pointer;
    }
    p {
      cursor: pointer;
      color: white;
      font-size: 28px;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 50px;
      height: 50px;
      background: rgba(0, 0, 0, 0.4);
      border-radius: 50%;
    }
    .left {
      position: absolute;
      top: 40%;
      left: 10px;
    }
    .right {
      position: absolute;
      top: 40%;
      right: 10px;
    }
    ul {
      list-style: none;
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      padding: 0;
      margin: 0;
      .color {
        background: url("../assets/img/banner/banner_point.png") no-repeat left
          center;
        background-size: 60px auto;
      }
      li {
        cursor: pointer;
        width: 30px;
        height: 30px;
        margin: 0.5rem;
        background: url("../assets/img/banner/banner_point.png") no-repeat right
          center;
        background-size: 60px auto;
        cursor: pointer;
        // box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
        &:hover {
          opacity: 0.8;
        }
      }
    }
  }
}
</style>
